module.exports = __webpack_public_path__ + "static/media/sair.6d17163c.svg";